import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { useTeenMemories } from "@/lib/api/memories";
import { Loader2 } from "lucide-react";
import { TeenMemoryItem } from "./teen-memory-item";

interface TeenMemoriesModalProps {
  teenId?: string;
  open: boolean;
  onClose: () => void;
}

export function TeenMemoriesModal({
  teenId,
  open,
  onClose,
}: TeenMemoriesModalProps) {
  const { data: memories, isLoading, error } = useTeenMemories(teenId || "");

  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent className="max-w-2xl overflow-hidden p-0">
        <DialogHeader className="p-4">
          <DialogTitle>Memory Management</DialogTitle>
          <div className="text-sm text-gray-500">
            {memories ? `${memories.length} saved memories` : ""}
          </div>
        </DialogHeader>
        {!teenId ? (
          <div className="text-gray-500">No teen ID provided</div>
        ) : isLoading ? (
          <div className="flex h-32 items-center justify-center">
            <Loader2 className="h-6 w-6 animate-spin text-gray-500" />
          </div>
        ) : error ? (
          <div className="text-red-500">
            Error loading memories: {error.message}
          </div>
        ) : !memories?.length ? (
          <div className="text-gray-500">No memories found</div>
        ) : (
          <div className="max-h-[60vh] space-y-4 overflow-y-auto p-4">
            {memories.map((memory) => (
              <TeenMemoryItem key={memory.id} memory={memory} userId={teenId} />
            ))}
          </div>
        )}
        {/* Add memory button and other modal actions can go here */}
      </DialogContent>
    </Dialog>
  );
}
